import React, { Component } from "react";
import cx from "classnames";
import scrollToComponent from "react-scroll-to-component";

import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

// Move these into bit
import NoItemsCTA from "../SharedComponents/NoItemsCTA/NoItemsCTA";
import ReactivateCTA from "../SharedComponents/ReactivateCTA/ReactivateCTA";
import OrderSummary from "../SharedComponents/OrderSummary/OrderSummary";
import { campaignState, getCustomizeOpenStatus }from "../../../utils/campaignState";
import boxStates from "../../../utils/boxStates";
import PageNav from "../SharedComponents/PageNav/PageNav";
import UpsellCTA from "./UpsellCTA/UpsellCTA";

import analytics, { events } from "../../../utils/analytics";
import { boxExpired } from "../../../utils/boxStatus";

import "../SharedComponents/fa-light.min.css";
import "../SharedComponents/fontawesome.min.css";
import "./CustomizePanel.css";

import env from "../../../utils/env";
import ProductContainerCustomizations from "../SharedComponents/ProductContainer/ProductContainerCustomizations";

class CustomizeView extends Component {
  state = {
    viewAll: false,
    currentPage: 1,
    pageLength: 5, // @TODO Get this number from the CMS
    initialDisplayAmount: 6 // @TODO Get this number from the CMS
  };

  getExtraSum = boxData => {
    if (!boxData || !boxData.customizations) {
      return 0;
    }

    let total = 0;
    const questions = boxData.customizations;
    questions.forEach(question => {
      if (!!question.additionalItems) {
        question.additionalItems.forEach(item => (total += item.price));
      }
    });

    return total;
  };

  getOpenStatus = boxData => {
    return getCustomizeOpenStatus(boxData);
  };

  getExtraChoiceCount = boxData => {
    let total = 0;
    const questions = boxData.customizations;
    for (const question of questions) {
      if (!!question.additionalItems) {
        total += question.additionalItems.length;
      }
    }

    return total;
  };

  getItems = (boxData, userData) => {
    const questions = boxData.customizations;
    if (!questions) {
      return [];
    }
    let items = [];

    for (let question of questions) {
      const grouping = question.questionType;
      const questionId = question.questionId;
      const extraChoicePrice = question.additionalItemCost;

      const surpriseItem = {
        id: 0,
        image:
          "https://static.fabfitfun.com/wp-content/uploads/2019/07/Choose-For-Me_1562709290.517_1562709290.6957.png",
        title: "Surprise Me",
        questionId,
        grouping
      };

      if (!userData.select && grouping === "select") {
        items.push(surpriseItem);
      } else {
        if (question.choice) {
          question.choice.questionId = questionId;
          question.choice.grouping = grouping;
          items.push(question.choice);
        }
        if (question.additionalItems) {
          for (let additionalItem of question.additionalItems) {
            additionalItem.questionId = questionId;
            additionalItem.grouping = grouping;
            additionalItem.extraChoicePrice = extraChoicePrice;
            items.push(additionalItem);
          }
        }
        if (!question.choice && !question.additionalItems) {
          items.push(surpriseItem);
        }
      }
    }
    return items;
  }

  getPageItems = (boxData, userData) => {
    const { currentPage, pageLength } = this.state;
    const items = this.getItems(boxData, userData);

    const start = (currentPage - 1) * pageLength;
    const end = start + pageLength;
    
    return items.slice(start, end);
  };

  showOrderSummary = boxData => {
    if (boxData.currentBox) {
      return boxData.currentBox.boxStatus !== boxStates.ASSIGNED;
    }
    return false;
  }

  render() {
    const { sysdata, showGrowthReactivatePopUp } = this.props;
    const { boxData = {}, userData = {}, isMobile, isProspect, isSharedBox } = sysdata;
    const { select } = userData;
    const isExpired = boxExpired(userData);
    const status = this.getOpenStatus(boxData);
    const cartSum = this.getExtraSum(boxData);
    const items = this.getItems(boxData, userData);
    const { pageLength, initialDisplayAmount } = this.state; // @TODO Get this number from the CMS
    const pageItems = this.getPageItems(boxData, userData);
    let participating = false;
    items.forEach(item => {
      if (item.grouping === "choice" && item.id !== 0) {
        participating = true;
        return;
      } 
    });

    const displayViewButton = !isMobile &&
      items.length > initialDisplayAmount;
    const displayUpsellCta = !select && status === campaignState.OPEN;
    const displayOrderSummary = this.showOrderSummary(boxData);
    const displaySidebar = displayUpsellCta || displayOrderSummary;

    const statusContainerStyle = cx({
      "d-flex": isMobile,
      "flex-jsa": isMobile
    });

    const statusStyle = cx({
      "c-black-60": true,
      "d-flex": true,
      "flex-aic": true,
      "case-caps": true,
      "pad-t-4": true
    });

    const titleStyle = cx({
      "mar-0": true,
      "ta-center": isMobile,
      "ff-pds": true,
      "fs-36": true,
      "fw-normal": true,
      "panel-title": true
    });

    const panelContainerStyle = cx({
      "d-flex": true,
      "flex-jsb": !isMobile,
      "flex-jse": isMobile,
      "flex-aic": isMobile, //|| status === campaignState.CLOSED,
      "flex-fdcr": isMobile
      // "flex-fdc": !isMobile && status === campaignState.CLOSED
    });

    const productGridWrapperStyle = cx({
      "w-60": !isMobile && displaySidebar,
      "w-100": !isMobile && !displaySidebar
    });

    const closedMsgStyle = cx({
      "closed-msg": true,
      "ta-center": true,
      "mar-a": isMobile,
      mobile: isMobile
    });

    return (
      <div className="customize-panel">
        <div className="mar-h-16">
          <h1
            ref={section => {
              this.Header = section;
            }}
            className={titleStyle}
          >
            Customizations
          </h1>
          <div className={statusContainerStyle}>
            <div className={statusStyle}>
              Status: {status}
              <div className={`status-light ${status} mar-4`}>&nbsp;</div>
            </div>
          </div>
        </div>

        {/* Season is closed and the user has no items */}
        {!participating && status === campaignState.CLOSED && !isSharedBox && (
          <div className={closedMsgStyle}>
            <i className="fal fa-hand-holding-box customize-closed-i" />
            <h3 className="ff-ns">Customization is currently closed.</h3>
            <p className="ff-ns fs-16 c-black-60">
              {!isExpired && (
                <span>
                  You will get an email when it's time to customize your next
                  box! Any customizations you make will display here.{" "}
                </span>
              )}
              <a href={`${env.envURL}/customize`} alt="">
                Learn more
              </a>
              .
            </p>
          </div>
        )}

        {/* Season is open but I have no items */}
        {status === campaignState.OPEN &&
          !participating &&
          !isExpired &&
          !isProspect && (
            <NoItemsCTA
              title="Customizations are Open!"
              desc="This is where you'll see your box customizations after you've selected them."
              ctaLabel="Customize Now"
              isMobile={isMobile}
              onClick={() => {
                window.location = `${env.envURL}/customize/`;
                analytics.track(events.CLICKED_ELEMENT, {
                  element_name: "Customize Now",
                  option_title: "Customizations"
                });
              }}
            />
          )}

        {/* Season is open and this is a shared box */}
        {status === campaignState.OPEN && isSharedBox && isProspect && (
          <NoItemsCTA
            title="Customizations are Open!"
            desc="Join now to customize your box!"
            ctaLabel="GET THE BOX"
            isMobile={isMobile}
            onClick={() => {
              window.location = `${env.envURL}/get-the-box/`;
              analytics.track("Clicked Element", {
                element_name: "Get the Box",
                option_title: "Customize"
              });
            }}
          />
        )}

        {/* User's Subscription is Expired */}
        {isExpired && (
          <ReactivateCTA
            baseClass="customize"
            title="Sorry, you have to be an active member to gain access to customizations!"
            desc="This is where you'll see your box customizations after you've selected them."
            ctaLabel="Reactivate Now"
            iconClass="fa-hand-holding-box"
            isMobile={isMobile}
            showGrowthReactivatePopUp={showGrowthReactivatePopUp}
            onClick={() => {
              analytics.track(events.CLICKED_ELEMENT, {
                element_name: "Reactivate Now",
                option_title: "Customizations"
              });
            }}
          />
        )}

        {!isExpired && participating && (
          <div className={panelContainerStyle}>
            <div className={productGridWrapperStyle}>
              <ProductContainerCustomizations
                open={status === campaignState.OPEN}
                products={isMobile ? pageItems : items}
                viewAll={this.state.viewAll}
                initialDisplayAmount={initialDisplayAmount}
                isSelect={select}
                isMobile={isMobile}
                isSharedBox={isSharedBox}
                isProspect={isProspect}
              />
            </div>
            {displaySidebar && !isSharedBox && (
              <div className="summary-details w-100">
                {displayOrderSummary && (
                  <OrderSummary
                    title="Extra Choices"
                    total={this.getExtraChoiceCount(boxData)}
                    sum={cartSum}
                    country={
                      userData.shippingAddress
                        ? userData.shippingAddress.country
                        : null
                    }
                    endDate={boxData.season.customizeEndDate}
                    footnote="Total does not reflect credit applied."
                  />
                )}
                {displayViewButton && (
                  <Button
                    type={buttonTypes.SECONDARY.value}
                    action={actionTypes.CALL_TO_ACTION.value}
                    label={!this.state.viewAll ? "View All" : "View Less"}
                    style={{ width: "100%", margin: "12px 0 0" }}
                    onClick={() => {
                      this.setState({ viewAll: !this.state.viewAll });
                      analytics.track(events.CLICKED_ELEMENT, {
                        element_name: !this.state.viewAll
                          ? "View All"
                          : "View Less",
                        option_title: "Customizations"
                      });
                    }}
                  />
                )}
                {displayUpsellCta && (
                  <UpsellCTA
                    title="Want more customizations?"
                    description="Upgrade now to select more products in your box each season."
                    ctaLabel="Upgrade"
                    onClick={() => {
                      analytics.track(events.CLICKED_ELEMENT, {
                        element_name: "Upgrade",
                        option_title: "Customize - Customization Upgrade"
                      });
                    }}
                  />
                )}
              </div>
            )}
          </div>
        )}
        {!displaySidebar && displayViewButton && (
          <Button
            type={buttonTypes.SECONDARY.value}
            action={actionTypes.CALL_TO_ACTION.value}
            label={!this.state.viewAll ? "View All" : "View Less"}
            style={{ width: "200px", margin: "16px auto", display: "block" }}
            onClick={() => {
              this.setState({ viewAll: !this.state.viewAll });
              analytics.track(events.CLICKED_ELEMENT, {
                element_name: !this.state.viewAll ? "View All" : "View Less",
                option_title: "Customizations"
              });
            }}
          />
        )}
        {isMobile && items.length > pageLength && !isExpired && (
          <PageNav
            maxPageCount={4}
            currentPage={this.state.currentPage}
            totalPages={Math.ceil(items.length / pageLength)}
            onChange={pg => {
              this.setState({ currentPage: pg });
              scrollToComponent(this.Header, {
                offset: 0,
                align: "top",
                duration: 500
              });
            }}
          />
        )}

        {/* User is expired and is a shared box and has customizations  */}
        {isExpired && isSharedBox && participating && (
          <React.Fragment>
            <div className={panelContainerStyle}>
              <div className={productGridWrapperStyle}>
                <ProductContainerCustomizations
                  open={status === campaignState.OPEN}
                  products={isMobile ? pageItems : items}
                  viewAll={this.state.viewAll}
                  initialDisplayAmount={initialDisplayAmount}
                  isSelect={select}
                  isMobile={isMobile}
                />
              </div>
              {displaySidebar && !isSharedBox && (
                <div className="summary-details w-100">
                  {displayOrderSummary && (
                    <OrderSummary
                      title="Extra Choices"
                      total={this.getExtraChoiceCount(boxData)}
                      sum={cartSum}
                      country={
                        userData.shippingAddress
                          ? userData.shippingAddress.country
                          : null
                      }
                      endDate={boxData.season.customizeEndDate}
                      footnote="Total does not reflect credit applied."
                    />
                  )}
                  {displayViewButton && (
                    <Button
                      type={buttonTypes.SECONDARY.value}
                      action={actionTypes.CALL_TO_ACTION.value}
                      label={!this.state.viewAll ? "View All" : "View Less"}
                      style={{ width: "100%", margin: "12px 0 0" }}
                      onClick={() => {
                        this.setState({ viewAll: !this.state.viewAll });
                        analytics.track(events.CLICKED_ELEMENT, {
                          element_name: !this.state.viewAll
                            ? "View All"
                            : "View Less",
                          option_title: "Customizations"
                        });
                      }}
                    />
                  )}
                  {displayUpsellCta && (
                    <UpsellCTA
                      title="Want more customizations?"
                      description="Upgrade now to select more products in your box each season."
                      ctaLabel="Upgrade"
                      onClick={() => {
                        analytics.track(events.CLICKED_ELEMENT, {
                          element_name: "Upgrade",
                          option_title: "Customize - Customization Upgrade"
                        });
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </React.Fragment>
        )}
        {/* User's Subscription is Expired and is a shared box and box has no customizations*/}
        {isExpired && isSharedBox && (
          <ReactivateCTA
            baseClass="customize"
            title="Sorry, you have to be an active member to gain access to customizations!"
            desc=""
            ctaLabel="Reactivate Now"
            iconClass="fa-hand-holding-box"
            isMobile={isMobile}
            showGrowthReactivatePopUp={showGrowthReactivatePopUp}
            onClick={() => {
              analytics.track(events.CLICKED_ELEMENT, {
                element_name: "Reactivate Now",
                option_title: "Customizations"
              });
            }}
          />
        )}
      </div>
    );
  }
}

export default CustomizeView;



// WEBPACK FOOTER //
// ./src/Components/Panels/CustomizePanel/CustomizePanel.js